import { IRegistrationEntry } from '../../models/registrationentry.model';
import { RegistrationEntryAction, RegistrationEntryActionType } from '../actions/registrationentry.action';

export const RegistrationEntryReducer = (
    state: IRegistrationEntry[] = new Array<IRegistrationEntry>(),
    action: RegistrationEntryAction
) => {
    switch (action.type) {
        case RegistrationEntryActionType.FETCH_REGISTRATIONENTRIES:
            return action.registrationEntries;
        case RegistrationEntryActionType.ADD_REGISTRATIONENTRY:
            return [
                ...state,
                action.registrationEntry
            ];
        case RegistrationEntryActionType.SET_REGISTRATIONENTRY_TO_COMPLETE:
            return state.map((registrationEntry: IRegistrationEntry) => {
                if (registrationEntry.id === action.id) {
                    registrationEntry = { ...registrationEntry, complete: true };
                }
                return registrationEntry;
            });
        case RegistrationEntryActionType.DELETE_REGISTRATIONENTRY:
            return state.filter((registrationEntry: IRegistrationEntry) =>
                registrationEntry.id !== action.id
            );
        default:
            return state;
    }
}